export type WirelessMedia = {
  webkitShowPlaybackTargetPicker?: () => void;
  webkitCurrentPlaybackTargetIsWireless?: boolean;
  remote?: {
    state: string;
    prompt: () => Promise<void>;
  };
};
export function isLocalMedia(source: string, base: string) {
  try {
    const url = new URL(source, base);
    return (
      !["http:", "https:"].includes(url.protocol) ||
      /^(localhost|0\.0\.0\.0|127\.[\d.]+|\[::1\])$/.test(url.hostname) ||
      url.hostname.endsWith(".localhost")
    );
  } catch {
    return true;
  }
}
export function wirelessSupport(media: WirelessMedia | null) {
  return {
    airplay: typeof media?.webkitShowPlaybackTargetPicker === "function",
    remote: typeof media?.remote?.prompt === "function",
    connected:
      Boolean(media?.webkitCurrentPlaybackTargetIsWireless) ||
      media?.remote?.state === "connected",
  };
}
export async function requestWirelessPlayback(
  media: WirelessMedia,
  kind: "airplay" | "remote",
) {
  if (
    kind === "airplay" &&
    typeof media.webkitShowPlaybackTargetPicker === "function"
  ) {
    media.webkitShowPlaybackTargetPicker();
  } else if (kind === "remote" && media.remote?.prompt) {
    await media.remote.prompt();
  } else {
    throw new Error("Unsupported playback target");
  }
}
